/*
 * @Author: ≡Christine 1204356932@qq.com
 * @Date: 2024-10-15 11:25:33
 * @LastEditors: ≡Christine 1204356932@qq.com
 * @LastEditTime: 2024-10-23 15:19:40
 * @FilePath: \management-portal\src\utils\http\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { useUserStore } from '@/store';
import router from '@/router';
import { storage } from '@/utils/storage';

const request = axios.create({
  baseURL: import.meta.env.VITE_GLOB_API_URL,
  timeout: 1000 * 10
});

request.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const userStore = useUserStore();
  if (config.headers) {
    config.headers['i-token'] = userStore.token;
    config.headers['language'] = storage.get('lang') ?? 'zh-CN';
  }
  return config;
});

let lastWarnNoLoginTime = 0;
const MIN_WARN_INTERVAL = 10000;

request.interceptors.response.use(
  (response: AxiosResponse) => {
    const { config } = response;
    const { download } = config;
    if (download) {
      return Promise.resolve(response.data);
    }
    if (response.data.code !== 0) {
      // token失效需要重新登录，直接跳转登录页
      if (response.data.code === 43265) {
        const currentTime = new Date().getTime();
        if (currentTime - lastWarnNoLoginTime > MIN_WARN_INTERVAL) {
          ElMessage.error(response.data.msg || '服务器端错误');
        }

        lastWarnNoLoginTime = currentTime;
        const userStore = useUserStore();
        userStore.resetUser();
        router.push('/login');
        return Promise.reject(new Error('请重新登录'));
      } else {
        ElMessage.error(response.data.msg || '服务器端错误');
      }

      return Promise.reject(new Error(response.data.msg || 'Error'));
    }

    return Promise.resolve(response.data);
  },
  (error: AxiosError) => {
    let message = error.message;
    if (message === 'Network Error') {
      message = '后端网络故障';
    } else if (message.includes('timeout')) {
      message = '接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = `接口${message.substring(message.length - 3)}异常`;
    }
    ElMessage.error(message);
    return Promise.reject(error);
  }
);

export default request;
